<div id="loaderFrame">
    <div id="InitLoader"></div>
</div>
<div id="form"></div>